import { TweenMax } from 'gsap';
import { SplitText } from '@/scripts/libs/SplitText';

const BlendDetailsInitial = (element) => {
  const title = element.querySelector('.blend-details__title');
  const text = element.querySelector('.blend-details__text');
  const rows = [...element.querySelectorAll('.blend-details__row')];

  const split = new SplitText(title, { charsClass: 'blend-details__title-char' });
  TweenMax.set(text, { y: 100, autoAlpha: 0 });
  TweenMax.set(rows, { y: 100, autoAlpha: 0 });
  TweenMax.set(split.chars, { y: 80, autoAlpha: 0 });
};

export default BlendDetailsInitial;
